// extracted by mini-css-extract-plugin
export default {"pill-container":"pill-container--mp-sso1B","pillContainer":"pill-container--mp-sso1B"};